<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar shape="square" size="large" :class="$style.avatar">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
    </div>
    <template #overlay>
      <a-menu>
        <!-- <a-menu-item @click="goToEditProfile">
          <a>
            <i class="fe fe-user" />
            Edit Profile
          </a>
        </a-menu-item> -->
        <!-- <a-menu-divider /> -->
        <a-menu-item @click="logout">
          <a class="text-danger">
            <i class="fe fe-log-out" />
            Keluar
          </a>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { UserOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  components: {
    UserOutlined,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const user = computed(() => store.getters['user/user'])

    const goToEditProfile = () => {
      router.push('/akun/edit-profile')
    }

    const logout = () => {
      if (route.meta.isMobileCms) {
        localStorage.removeItem('mobile_cms_token')
        localStorage.removeItem('mobile_cms_user')
        localStorage.removeItem('mobile_cms_role')
        router.push('/mobile-cms/login')
        return
      }
      store.dispatch('user/LOGOUT')
    }

    return {
      user,
      goToEditProfile,
      logout,
    }
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
